import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../../core/config';
import { LoaderService } from '../../services/loader/loader.service';
import { ToastComponent } from '../../shared/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class VendorAddressService {
  apiUrl : string = Config.API_ENDPOINT;
	loginData: any;
	headers : any;
	accessToken : any;
	userId : any;
  constructor(
    public http: HttpClient,
  	public loadingService : LoaderService,
  	public snackbarCmp : ToastComponent
  ) {
    this.headers = new Headers();

    this.headers.append('Access-Control-Allow-Origin' , '*');
    this.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
    this.headers.append('Accept','application/json');
    this.headers.append('content-type','application/json');
    this.getLoginUserData();
   }

   getLoginUserData(){
    let loginUserData = JSON.parse(localStorage.getItem("loginUser"));
    if(loginUserData){
      this.accessToken = loginUserData['id'];
      this.userId = loginUserData['userId'];
    }
    
  }

  getVendorAddressDetails(VendorAddressId){

    this.getLoginUserData();

    this.loadingService.showLoading();
  
    let filterJSON = {	
      "include":['user','vendor','services','plan'],	
      "order": "createdAt DESC"
    };

  let filter = encodeURI(JSON.stringify(filterJSON));

  
    let VendorAddressURL = this.apiUrl + 'user-addresses/' +VendorAddressId
                  + '?access_token=' + this.accessToken
                   + '&filter=' + filter;


    return new Promise((resolve, reject) => {
      this.http.get(VendorAddressURL).subscribe(res => {
      
        this.loadingService.hideLoading();
            resolve(res);
      },(err)=>{
        this.loadingService.hideLoading();
            this.snackbarCmp.presentToast(Config.GENERIC_ERROR);
            reject(err);
      });
    });
  }

  getAllVendorAddresss(userId){
    this.getLoginUserData();

  this.loadingService.showLoading();
  
  let filterJSON = {	
    "where":{
      "userId":userId
    },
      "order": "createdAt DESC"
    };
  

  let filter = encodeURI(JSON.stringify(filterJSON));

  let allVendorAddressURL = this.apiUrl + 'user-addresses/' 
                + '?access_token=' + this.accessToken
                + '&filter=' + filter;

  return new Promise((resolve, reject) => {
    this.http.get(allVendorAddressURL).subscribe((res:any) => {
      
        this.loadingService.hideLoading();
        resolve(res);
      
    },(err)=>{
      this.loadingService.hideLoading();
          this.snackbarCmp.presentToast(Config.GENERIC_ERROR);
          reject(err);
    });
  });
}

addVendorAddress(VendorAddressInfo) {
  this.getLoginUserData();
  //firstName,lastName,mobileNo,companyName,email,username,password, realm
    this.loadingService.showLoading();

    let addVendorAddressURL = this.apiUrl + 'user-addresses/' 
            + '?access_token=' + this.accessToken
   

  
  return new Promise((resolve, reject) => {

    this.http.post(addVendorAddressURL, VendorAddressInfo,{headers:this.headers,withCredentials: true})
      .subscribe(res => {
          this.loadingService.hideLoading();
          // this.dialog.openContentDialog(Config.MESSAGE.USER.ADD_TITLE,Config.MESSAGE.USER.ADD);
          // this.snackbarCmp.presentToast(Config.MESSAGE.USER.ADD);
        resolve(res);
      }, (err) => {
        this.loadingService.hideLoading();
        this.snackbarCmp.presentToast(Config.MESSAGE.USER.SIGNUP_ERR);
        reject(err);
      });
  });
}



editVendorAddress(VendorAddressInfo,VendorAddressId,successMsg = Config.MESSAGE.USER.EDIT) {
        this.getLoginUserData();
    this.loadingService.showLoading();
    


    let editVendorAddressURL = this.apiUrl + 'user-addresses/' + VendorAddressId + '?access_token=' + this.accessToken;
   

  
  return new Promise((resolve, reject) => {

    this.http.patch(editVendorAddressURL, VendorAddressInfo,{headers:this.headers,withCredentials: true})
      .subscribe(res => {
          this.loadingService.hideLoading();
          this.snackbarCmp.presentToast(successMsg);
        resolve(res);
      }, (err) => {
        this.loadingService.hideLoading();
        this.snackbarCmp.presentToast(Config.GENERIC_ERROR);
        reject(err);
      });
  });
}

deleteVendorAddress(VendorAddressId){
        this.getLoginUserData();

  //firstName,lastName,mobileNo,companyName,email,username,password, realm

  let dialogTitle = "Delete VendorAddress";
    let dialogContent = Config.MESSAGE.USER.DELETE_CONFIRM;
        return new Promise((resolve, reject) => {
    
  // this.dialog.openDialog(dialogTitle,dialogContent).then((isOkay)=>{
  //       if(isOkay){
        this.loadingService.showLoading();
        
        let deleteVendorAddressURL = this.apiUrl + 'user-addresses/' + VendorAddressId + '?access_token=' + this.accessToken;
       

      

        this.http.delete(deleteVendorAddressURL,{headers:this.headers,withCredentials: true})
          .subscribe(res => {
              this.loadingService.hideLoading();
              this.snackbarCmp.presentToast(Config.MESSAGE.USER.DELETE);
            resolve(res);
          }, (err) => {
            this.loadingService.hideLoading();
            this.snackbarCmp.presentToast(Config.GENERIC_ERROR);
            reject(err);
         });
        // }
        // });

  })
    
    
}

}
